import "../css/Popups.css";
import emailjs from '@emailjs/browser'; 


function Contact({onClose}){

    
    function reset(){
        let inputField =document.getElementsByClassName("input-field");
        inputField[0].value = "";
        inputField[1].value = "";
    }
    const sendEmail = (e)=>{
        e.preventDefault();
        emailjs.sendForm(process.env.React_App_Service_Id, process.env.React_App_Template_Id, e.target, process.env.React_App_Public_Key);
        reset();
        alert("Message Sent. Response will be sent as soon as possible");
    }

    return(
        <div className="shade">
            <section id="popup">
                <div className="top">
                    <h1>Contact</h1>
                    <button onClick={onClose} className="closeBtn">X</button>
                </div>

                <div className="mid">
                    <h2>Leave a message</h2>
                    <form className="contactForm" onSubmit={sendEmail}>
                        <div>
                            <input type="email" name="email" className="input-field" placeholder="E-mail" />
                        </div>
                        <div>
                            <textarea name="message" className="input-field" placeholder="Message..."></textarea>
                        </div>
                        <div>
                            <button id="submit-btn">Submit</button>
                        </div>
                    </form>
                </div>

                <div className="bottom">
                    <img src={require("../images/about-bottom.png")} alt="" width="100%" height="50px" />
                </div>
            </section>
        </div>

    )
}
 export default Contact;